'use client';

import { useTranslations } from 'next-intl';
import { H1, P } from './styleConstants';
import { BookTestCta, ComingSoonEyebrow } from './BookTestCta';
import { useBloodVisionBooking } from './hooks/useBloodVisionBooking';
import { SplineViewer } from 'components/shared/SplineViewer/SplineViewer';
import {
  bloodVisionDesktopSrc,
  bloodVisionMobileSrc,
} from 'components/shared/SplineViewer/scenes';
import styles from './HeroSection.module.css';

export const BloodVision_HeroSection = ({
  className,
}: {
  className?: string;
}) => {
  const t = useTranslations('bloodVision');
  const booking = useBloodVisionBooking();

  return (
    <section
      className={className ? `${styles.root} ${className}` : styles.root}
    >
      <div className={styles.canvasContainer}>
        <SplineViewer
          desktopSrc={bloodVisionDesktopSrc}
          mobileSrc={bloodVisionMobileSrc}
        />
      </div>
      {/* <Container className="bv-hero-content">
          <div className="main-content">
            <H1>
              Introducing
              <br />
              Blood Vision
            </H1>
            <P>
              Discover the world of Blood Vision, a new and exciting NFT
              collection.
            </P>
          </div>
          <div className="secondary-content">

          </div>
        </Container> */}

      <div
        className={styles.mainContent}
        data-cta={booking ? undefined : 'none'}
      >
        <ComingSoonEyebrow />
        <H1>{t.rich('hero.title', { br: () => <br /> })}</H1>
        <P>
          {t.rich('hero.subtitle', {
            tm: (chunks) => <span style={{ opacity: '0.5' }}>{chunks}</span>,
          })}
        </P>
        {booking ? (
          <div className={styles.ctaContainer}>
            <BookTestCta />
          </div>
        ) : null}
      </div>
    </section>
  );
};
